import React, { useEffect, useRef, useState } from "react";
import * as Marker from "@markerjs/markerjs3";

const ViewAnnotation = ({ image, mode }) => {
  const viewerContainer = useRef(null);
  const viewer = useRef(null);

  useEffect(() => {
    if (!viewer.current && viewerContainer.current) {
      const targetImg = document.createElement("img");
      targetImg.src = `${process.env.REACT_APP_API_URL}/photoshoot/${mode}/full/${image.fname}`;

      const viewerArea = new Marker.MarkerView();
      viewerArea.targetImage = targetImg;

      // set a reasonable size for the target image in the editor
      const viewerAreaWidth = viewerContainer.current.clientWidth;
      viewerArea.targetWidth =
        viewerAreaWidth < 400
          ? 400
          : viewerAreaWidth < 2000
            ? Math.round((viewerAreaWidth * 0.9) / 10) * 10
            : -1;

      viewer.current = viewerArea;
      viewerContainer.current.appendChild(viewerArea);
      if (false && image.va_feedback) {
        const annotation = JSON.parse(image.va_feedback);
        viewerArea.show(annotation);
      }
      document
        .querySelector("mjs-marker-view")
        .shadowRoot.querySelector("a").style.display = "none";
    }
  }, [image]);

  return (
    <>
      <div ref={viewerContainer}></div>
    </>
  );
};

export default ViewAnnotation;
